import gql from 'graphql-tag'
import { standardTeamResult, teamConnectionData } from 'store/fragments'

// QUERIES
export const TeamQuery = gql`
	query teamQuery($companySlug: String, $id: String, $slug: String,$companyId:String) {
		feedteams(companyslug: $companySlug, slug: $slug,companyid:$companyId) {
		edges{node{	...standardTeamResult}}
		}
	}
	${standardTeamResult}
`
export const TeamDepartmentQuery = gql`
	query teamDepartments {
		teamDepartmentCollection {edges{node{
			id
			key
		}}}
	}
`
export const TeamsQuery = gql`
	query teamsQuery($name: String, $companyId: String, $companySlug: String,$locationids:[String]) {
		feedteams(name: $name, companyid: $companyId, companyslug: $companySlug,locationids:$locationids) {
			edges{node{...standardTeamResult}}
		}
	}
	${standardTeamResult}
`
export const TeamsDepartmentsGroupedQuery = gql`
	query teamDepartmentCollection($name: String) {
	  teamCollection(
    filter:{
      name: {ilike:$name}
      active: {eq: true}
    }
  ){
    edges{
      node{
        id
        name
		
        teamDepartment{
          id
          key
		  roTitle
			enTitle
			
        }
      }
    }
  }

	}
`

export const FeedTeamsQuery = gql`
	query feedTeams(
		$name: String
$industryids: [String]
$departmentids: [String]
$locationids: [String]
$companyid: String
$size: [String]
$averageage: [String]
$first: Int
$after: Cursor
) {
		feedteams(
			name:$name
industryids:$industryids
departmentids:$departmentids
locationids:$locationids
companyid:$companyid
size:$size
averageage:$averageage
first:$first
after:$after
		) {
			...teamConnectionData
		}
	}
	${teamConnectionData}
`

// MUATTIONS
export const UpdateTeamDetails = gql`
	mutation handleTeam($details: TeamUpdateInput!) {
		updateTeamCollection(set: $details) {
			records{...standardTeamResult}
		}
	}
	${standardTeamResult}
`

export const AddTeam = gql`
	mutation insertIntoTeamCollection($details: [TeamInsertInput!]!) {
		insertIntoTeamCollection(objects: $details) {
			records{...standardTeamResult}
		}
	}
	${standardTeamResult}
`
export const AddTeamMembers = gql`
	mutation insertIntoTeamMemberCollection($data: [TeamMemberInsertInput!]!) {
		insertIntoTeamMemberCollection(objects: $data) {
			records{id}
		}
	}
	${standardTeamResult}
`
export const DeleteTeamMember = gql`
	mutation deleteFromTeamMemberCollection($id: String) {
		deleteFromTeamMemberCollection(filter:{id:{eq:$id}}) {
			records{id}
		}
	}
	${standardTeamResult}
`
export const DeleteTeam = gql`
	mutation updateTeamCollection($id:String! ) {
		updateTeamCollection(
    filter:{id:{eq:$id}}
    set:{active:false}
  ) {
	records{...standardTeamResult}
		}
	}
	${standardTeamResult}

`
